import { render, staticRenderFns } from "./authority_functions.vue?vue&type=template&id=0d5b3b6d&scoped=true"
import script from "./authority_functions.vue?vue&type=script&lang=js"
export * from "./authority_functions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b3b6d",
  null
  
)

export default component.exports